import { Checkbox, Switch } from 'antd';
import Text from 'components/Text';
import { useMemo } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { IPermissionConfigRes } from 'features/settingService/services/types/permission';
import settingServiceActions from 'features/settingService/services/actions';


interface VerifyPinHeaderProps {
  label: string;
}

const VerifyPinHeader = ({ label }: VerifyPinHeaderProps) => {

  const dataChanged = settingServiceSelectors.getPermissionConfigChanged();
  const dataFiltered= settingServiceSelectors.getPermissionConfigFiltered();
  const dispatch = useAppDispatch();

  const getUpdateData = (data: IPermissionConfigRes[] | null, checked: boolean) => {    
    return (data ?? []).map((permission) => {
        return {
          ...permission,
          features: permission.features.map(act => {
          return {
            ...act,
            requirePin: checked
          };
        })
      };
    });

  };

  const handleChange = (checked: boolean) => {
    dispatch(settingServiceActions.updatePermissionConfigChanged(getUpdateData(dataChanged, checked)));
    dispatch(settingServiceActions.updatePermissionConfigFiltered(getUpdateData(dataFiltered, checked)));
  };

  const allValueInRole = useMemo(() => {
    return (dataFiltered ?? []).flatMap(permission => permission.features.map(act => act.requirePin));
  }, [dataFiltered]);

  const checkAll = useMemo(() => {
    return !allValueInRole.some(i => i === false);
  }, [allValueInRole]);
  
  return (
    <VerifyPinHeaderWrapper>
      <Switch 
        checkedChildren="ON"
        unCheckedChildren="OFF"
        checked={checkAll} 
        onChange={(checked) => handleChange(checked)} />
      <Title variant='H9'>
        {label}
      </Title>
    </VerifyPinHeaderWrapper>
  );
};

export default VerifyPinHeader;

const VerifyPinHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 8px;
`;

const Title = styled(Text)`
  white-space: nowrap;
`;